<template>
  <div class="wrap">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div>
        <div class="check-wrap">
          <div class="check-parts">{{ checkList.length }}件を選択中</div>
          <div class="check-parts pointer" @click="clearList"><i class="el-icon-remove-outline" style="font-size:14px;"></i>選択を解除</div>
          <addListButton :checkList.sync="checkList" :checkAll_val.sync="checkAll_val" :sns_type="'instagram'" :from_media_search="true" />
        </div>
      </div>
    </div>
    <!-- ユーザーページ -->
    <div class="search-page-wrap">
      <div class="data-table-title">
        <div>クリエイティブ検索</div>
        <div v-if="!loading" class="data-table-result-count">
          該当するクリエイティブ
          <span class="data-table-result-count-num">{{ result_count == 1000 ? "1000+" : result_count }}</span
          >件
        </div>
        <div class="flex-space"></div>
        <div class="data-table-menu">
          <el-switch v-model="caption_switch" inactive-text="全表示" active-text="最小表示"></el-switch>
          <el-dropdown trigger="click">
            <el-button type="info" style="margin-left:20px">
              <font-awesome-icon icon="calendar-alt" style="margin-right:5px" />
              {{ period == "1month" ? "直近30日" : period == "3month" ? "直近90日" : period == "1year" ? "直近1年" : "期間を選択" }}
              <font-awesome-icon icon="caret-down" style="margin-left:5px;" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="changePeriod('1month')">直近30日</el-dropdown-item>
              <el-dropdown-item @click.native="changePeriod('3month')">直近90日</el-dropdown-item>
              <el-dropdown-item @click.native="changePeriod('1year')">直近1年</el-dropdown-item>
              <el-dropdown-item @click.native="changePeriod('all')">全期間</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- テーブルタイトル -->
      <div class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
        <div class="data-table-th-checkbox" style="padding-left: 20px;">
          <div class="checkbox_inner" :class="check_list_status" @click="checkAll_pagination('auto')"></div>
          <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
            <span style="height:20px">
              <div class="checkbox-select-wrap" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="checkAll_pagination('select')">表示中を全て選択({{ list.media ? list.media.length : "-" }}件)</el-dropdown-item>
              <el-dropdown-item @click.native="checkAll_pagination('unselect')">表示中を全て選択解除({{ list.media ? list.media.length : "-" }}件)</el-dropdown-item>
              <el-dropdown-item @click.native="checkAll_pagination('selectAll')" divided>
              <span>リスト内を全て選択({{ media_all.length }}件)</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="checkAll_pagination('unselectAll')" v-if="checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>  
        </div>
        <div class="data-table-media-photo" style="margin-left:20px">クリエイティブ</div>
        <div class="data-table-media-caption">キャプション</div>
        <div class="data-table-media-eg pointer" @click="sortBy('engagement_count')" :class="[sort_key === 'engagement_count' ? 'data-table-sort-active' : '']">
          <el-tooltip placement="top">
            <div slot="content">いいね数とコメント数の合計です。</div>
            <span class="data-table-underline">
              EG
              <font-awesome-icon :icon="['fas', 'question-circle']" />
            </span>
          </el-tooltip>
          <font-awesome-icon icon="arrow-up" style="margin-left:3px;" v-show="sort_key == 'engagement_count' && sort_order == 'asc'" />
          <font-awesome-icon icon="arrow-down" style="margin-left:3px;" v-show="sort_key == 'engagement_count' && sort_order == 'desc'" />
        </div>

        <div class="data-table-media-comment pointer" @click="sortBy('comments_count')" :class="[sort_key === 'comments_count' ? 'data-table-sort-active' : '']">
          <span class="data-table-underline">コメント</span>
          <font-awesome-icon icon="arrow-up" style="margin-left:3px;" v-show="sort_key == 'comments_count' && sort_order == 'asc'" />
          <font-awesome-icon icon="arrow-down" style="margin-left:3px;" v-show="sort_key == 'comments_count' && sort_order == 'desc'" />
        </div>
        <div class="data-table-media-eg-rate pointer" @click="sortBy('average_engagement_rate')" :class="[sort_key === 'engagement_rate' ? 'data-table-sort-active' : '']">
          <el-tooltip placement="top">
            <div slot="content">
              エンゲージメント率(EngagementRate)を示しています。
              <br />いいね数とコメント数の合計をフォロワー数で割った比率です。
              <br />
            </div>
            <span class="data-table-underline">
              EGR
              <font-awesome-icon :icon="['fas', 'question-circle']" />
            </span>
          </el-tooltip>
          <font-awesome-icon icon="arrow-up" style="margin-left:3px;" v-show="sort_key == 'average_engagement_rate' && sort_order == 'asc'" />
          <font-awesome-icon icon="arrow-down" style="margin-left:3px;" v-show="sort_key == 'average_engagement_rate' && sort_order == 'desc'" />
        </div>
        <div class="data-table-media-date pointer" @click="sortBy('timestamp')" :class="[sort_key === 'timestamp' ? 'data-table-sort-active' : '']">
          <span class="data-table-underline">投稿日</span>
          <font-awesome-icon icon="arrow-up" style="margin-left:3px; color:#666;" v-show="sort_key == 'timestamp' && sort_order == 'asc'" />
          <font-awesome-icon icon="arrow-down" style="margin-left:3px; color:#666;" v-show="sort_key == 'timestamp' && sort_order == 'desc'" />
        </div>
      </div>

      <!-- テーブルループ -->
      <div class="data-table-list-nolist" v-show="nopost">
        <img src="../../assets/post_image.png" style="opacity:0.5" alt />
        <div style="font-size:20px; font-weight:700; margin-bottom:10px;">クリエイティブが見つかりませんでした</div>
        <div style="margin-bottom: 30px;">条件を変えて検索してみましょう</div>
      </div>
      <transition name="fade">
        <div class="data-table-list-nolist" v-show="multiple_load">
          <img src="../../assets/loading_.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">もう少々お待ちください</div>
          <div>検索対象が多いため時間がかかっています。キーワード検索は最大で1分程度かかる場合もあります。</div>
          <div style="margin-top:10px">
            <a href="https://help.reech.co.jp/ja/articles/5938292" target="_blank" class="router-link"
              >クリエイティブ検索に時間がかかる理由は？ <font-awesome-icon :icon="['far', 'external-link']" style="margin-left: 3px;"
            /></a>
          </div>
        </div>
      </transition>
      <div class="data-table-media-tr" v-for="(media, index) in list.media" :key="media.id" @click="check_hover ? '' : detail(index)">
        <div class="data-table-th-checkbox" @mouseover="check_hover = true" @mouseleave="check_hover = false">
          <div class="data-table-th-checkbox">
            <input type="checkbox" class="checkbox-original" v-model="checkList" :value="media.media_id" :id="media.media_id + 'checkbox'" />
            <label class="checkbox_inner" :for="media.media_id + 'checkbox'"> </label>
          </div>
        </div>
        <div class="data-table-media-photo pointer">
          <el-image
            :src="s3BaseUrl + '/postdata/' + media.shortcode + '_m.jpg'"
            :class="[!caption_switch ? 'data-table-photo-all' : 'data-table-photo']"
            fit="cover"
          >
            <div slot="error" :class="[!caption_switch ? 'data-table-photo-all-noimg' : 'data-table-photo-noimg']">
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
            </div>
          </el-image>
          <div class="pr_type" v-show="media.pr_flag">
            <div class="pr_tag">PR</div>
          </div>
        </div>
        <div class="data-table-media-caption captionarea pointer">
          <div :class="[!caption_switch ? 'data-table-media-captionarea-all' : 'data-table-media-captionarea']">
            <span v-html="$options.filters.searchHighlight(media.caption, media_search.keyword, media_search.pr)"></span>
          </div>
          <div class="data-table-media-profilearea">
            <img class="data-table-media-profilephoto" :src="media.profile_picture_url" @error="imgError(index)" />
            <div>{{ media.account_name }}</div>
          </div>
        </div>
        <div class="data-table-media-eg">{{ media.engagement }}</div>
        <div class="data-table-media-comment">{{ media.comment }}</div>
        <div class="data-table-media-eg-rate">{{ media.EGR }}%</div>
        <div class="data-table-media-date">{{ media.timestamp }}</div>
      </div>

      <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more" style="font-size:40px;"></div>
        <div slot="no-results" style="font-size:40px;"></div>
      </infinite-loading>

      <!-- ドロワー -->
      <div :class="[drawer ? 'overlay open' : 'overlay']" @click="closeDrawer"></div>
      <div :class="[drawer ? 'media-detail-modal open' : 'media-detail-modal']">
        <div class="detail-modal" v-if="drawer">
          <div class="detail-profile-wrap">
            <div class="detail-profile-img-area">
              <img class="detail-profile_img pointer" :src="list.media[index].profile_picture_url" @error="imgError(index)" @click="openDrawer_i(list.media[index])" />
            </div>
            <div class="detail-profile-name-area">
              <div class="detail-profile-name report pointer" @click="openDrawer_i(list.media[index])">
                {{ list.media[index].account_name }}
                <font-awesome-icon :icon="['fal', 'info-circle']" style="margin-left:3px; color:#666" />
              </div>
              <div class="detail-sponsor" v-show="list.media[index].sponsor">
                <span>{{ list.media[index].sponsor }}</span>とのタイアップ投稿
              </div>
              <div class="detail-location" v-show="list.media[index].location">
                <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="margin-right: 3px;" />
                {{ list.media[index].location }}
              </div>
            </div>
          </div>
          <div class="detail-img-wrap">
            
            <!-- コストの関係でリールについては動画ではなくサムネイル表示とする -->
            <!-- <div v-if="list.media[index].is_reel == 1">
              <video class="detail-img" :src="s3BaseUrl + '/reel/' + list.media[index].ig_id + '/' + list.media[index].media_id + '/video.mp4'" muted loop controls alt=""></video>
            </div>
            
            <div v-else class="detail-img-area"> -->
            <div class="detail-img-area">
              <div v-loading="detail_loading" style="min-height:343px;" class="detail-img-loading" v-if="detail_loading"></div>
              <el-image
                :src="s3BaseUrl + '/postdata/' + list.media[index].shortcode + '.jpg'"
                class="detail-img"
                v-show="!detail_loading"
                @load="imgDetailLoaded()"
                @error="imgDetailError()"
              >
                <div slot="error" class="detail-img error">
                  <font-awesome-icon icon="exclamation-circle" />
                </div>
              </el-image>
              <div class="pr_type drawer" v-show="list.media[index].pr_flag">
                <div class="pr_tag">PR</div>
              </div>
              <div class="media_type" v-show="normalizeCreativeSns(list.media[index]) === 'instagram' && list.media[index].media_type == 'GraphVideo' && !detail_loading">
                <font-awesome-icon :icon="['far', 'play']" class="media_tag" />
              </div>
              <div class="media_type" v-show="normalizeCreativeSns(list.media[index]) === 'instagram' && list.media[index].media_type == 'GraphSidecar' && !detail_loading">
                <font-awesome-icon :icon="['far', 'clone']" class="media_tag" />
              </div>
            </div>
            <div class="detail-tagged-user-area">
              <div class="tagged-user-icon-wrap">
                <div class="tagged-user-icon" v-show="list.media[index].tagged_user_1" @click="tagged_show">
                  <font-awesome-icon icon="user-friends" />
                </div>
              </div>
              <transition name="fade">
                <div class="tagged-user-wrap" v-show="tagged_user">
                  <div class="tagged-user" v-show="list.media[index].tagged_user_1">{{ list.media[index].tagged_user_1 }}</div>
                  <div class="tagged-user" v-show="list.media[index].tagged_user_2">{{ list.media[index].tagged_user_2 }}</div>
                  <div class="tagged-user" v-show="list.media[index].tagged_user_3">{{ list.media[index].tagged_user_3 }}</div>
                  <div class="tagged-user" v-show="list.media[index].tagged_user_4">{{ list.media[index].tagged_user_4 }}</div>
                  <div class="tagged-user" v-show="list.media[index].tagged_user_5">{{ list.media[index].tagged_user_5 }}</div>
                </div>
              </transition>
            </div>
          </div>
          <div class="detail-engage-area">
            <div class="detail-engage-box flex-row" style="gap: 6px">
              <div class="flex-row" v-if="list.media[index].video_play_count > 0">
                <font-awesome-icon :icon="['far', 'play']" style="margin-right:3px; font-size:12px" />
                {{ list.media[index].video_play_count }}
              </div>
              <div class="flex-row" v-if="list.media[index].like_count >= 0">
                <font-awesome-icon :icon="['fal', 'heart']" style="margin-right:3px; font-size:12px" />
                {{ list.media[index].like_count }}
              </div>
              <div class="flex-row" v-else>
                <font-awesome-icon :icon="['fal', 'heart']" style="margin-right:3px; font-size:12px" />
                非表示
              </div>
              <font-awesome-icon :icon="['fal', 'comment']" style="margin-right:3px; font-size:12px" />
              {{ list.media[index].comments_count }}
              <span style="margin-left:6px; font-size:12px">EGR</span>
              {{ list.media[index].EGR }}%
            </div>
            <div v-if="externalPostUrl(list.media[index])" class="detail-link">
              <a :href="externalPostUrl(list.media[index])" target="_blank" rel="noopener noreferrer">
                <el-button type="info" size="medium" style="margin-left:10px;">{{ externalPostLabel(list.media[index]) }}</el-button>
              </a>
            </div>
          </div>
          <div class="detail-caption-area">
            <pre class="caption-in" v-html="$options.filters.searchHighlight(list.media[index].caption, media_search.keyword, media_search.pr)"></pre>
            <div class="detail-date">{{ list.media[index].timestamp }}</div>
          </div>
        </div>
      </div>

      <div :class="[drawer_i ? 'i-detail-modal open' : 'i-detail-modal']" style="z-index:1005" id="i-detail-scroll">
        <router-view ref="iDetail" v-show="drawer_i"></router-view>
      </div>
      <div :class="[drawer_i ? 'overlay-b open' : 'overlay-b']" @click="closeDrawer_i" style="z-index: 1004"></div>
    </div>
  </div>
</template>

<script>
import addListButton from "../list/add_list_button";
const root = process.env.VUE_APP_API;
const mediaAPI = root + "/api/search/media_search";
const pr_word =
  "#pr$|#pr\n|#pr#|#pr\s|#pr\W[^(じゃない|ではない)]|#promotion|#sponsored|#(w*[一-龠_ぁ-ん_ァ-ヴーａ-ｚＡ-Ｚa-zA-Z0-9]+|[a-zA-Z0-9_]+|[a-zA-Z0-9_]w*)_pr|#(w*[一-龠_ぁ-ん_ァ-ヴーａ-ｚＡ-Ｚa-zA-Z0-9]+|[a-zA-Z0-9_]+|[a-zA-Z0-9_]w*)_sponsored|#(w*[一-龠_ぁ-ん_ァ-ヴーａ-ｚＡ-Ｚa-zA-Z0-9]+|[a-zA-Z0-9_]+|[a-zA-Z0-9_]w*)_partner|#(w*[一-龠_ぁ-ん_ァ-ヴーａ-ｚＡ-Ｚa-zA-Z0-9]+|[a-zA-Z0-9_]+|[a-zA-Z0-9_]w*)_ad"; //eslint-disable-line

export default {
  name: "media",
  components: {
    addListButton,
  },
  data() {
    return {
      list: [],
      media_all: [],
      offset: 0,
      next_cursor: "",
      index: 0,
      loading: false,
      detail_loading: false,
      result_count: 1,
      checkList: [],
      checkAll_val: false,
      checkAll_dropdown: false,
      check_hover: false,
      keyword: "",
      category: "",
      sort_key: "",
      sort_order: "",
      period: "1year",
      drawer: false,
      drawer_i: false,
      tagged_user: false,
      infiniteId: +new Date(),
      caption_switch: true,
      pr_word_regexp: new RegExp(pr_word, "ig"),
      nopost: false,
      multiple_flag: false,
      multiple_load: false,
      search_dropdown: "",
      search_dropdown_regexp: "",
      search_dropdown_add: "",
      search_dropdown_add_regexp: "",
      requestId: 0,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    media_search() {
      return this.$store.state.media_search;
    },
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    check_list_status() {      
      if (this.list.media) {
        let checkCount = 0;
        for (let i = 0; i < this.list.media.length; i++) {
          for (let ii = 0; ii < this.checkList.length; ii++) {
            if (this.list.media[i]['media_id'] == this.checkList[ii]) checkCount += 1;
          }
        }        
        if (checkCount == this.list.media.length) {
          return "all";
        } else if (checkCount > 0) {
          return "some";
        } else {
          return "none";
        }
      } else {
        return "none";
      }
    },
  },
  mounted() {
    this.loadQuery();
    this.$store.dispatch("changeActive", "media_search");
  },
  methods: {
    loadQuery() {
      this.sort_order = "desc";
      this.sort_key = "timestamp";
      this.list = [];
      this.checkList = [];
      this.checkAll_val = false;
      this.offset = 0;
      this.next_cursor = "";
      this.result_count = 1;
      this.infiniteId += 1;
    },
    infiniteHandler($state) {
      this.nopost = false;
      this.loading = true;
      this.multiple_flag = true;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      setTimeout(() => {
        if (this.multiple_flag && this.offset == 0) {
          this.multiple_load = true;
        }
      }, 3000);
      var params = new URLSearchParams();
      params.append("params", JSON.stringify(this.media_search));
      params.append("offset", this.offset);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("period", this.period);
      params.append("next_cursor", this.next_cursor);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      this.axios.post(mediaAPI, params, { requestId: this.requestId }).then((response) => {
        this.multiple_flag = false;
        this.multiple_load = false;
        this.result_count = response.data.result_count;
        this.media_all = response.data.media_all;
        if (this.result_count > this.offset) {
          if (this.offset == 0) {
            this.list = response.data;
          } else {
            var newmedia = this.list.media.concat(response.data.media);
            this.list.media = newmedia;
          }
          $state.loaded();
          this.offset = response.data.offset;
          this.next_cursor = response.data.next_cursor;
        } else {
          if (response.data.result_count == 0) this.nopost = true;
          $state.complete();
        }
        this.loading = false;
      });
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.sort_key = value;
      this.list = [];
      this.offset = 0;
      this.next_cursor = "";
      this.infiniteId += 1;
    },
    detail(index) {
      this.index = index;
      this.drawer = true;
      this.detail_loading = true;
    },
    tagged_show() {
      this.tagged_user = !this.tagged_user;
    },
    closeDrawer() {
      this.drawer = false;
    },
    changePeriod(value) {
      this.period = value;
      this.list = [];
      this.offset = 0;
      this.next_cursor = "";
      this.result_count = 1;
      this.infiniteId += 1;
    },
    openDrawer_i(media) {
      const row = typeof media === "string" ? { account_name: media, sns_type: null } : media || {};
      const sns = this.normalizeCreativeSns(row);
      this.drawer_i = true;
      document.documentElement.style.overflow = "hidden";
      const routeName = sns === "twitter" ? "media_twittererDetailDrawer" : "media_influencerDetailDrawer";
      this.$router.push({
        name: routeName,
        params: {
          account_name: row.account_name,
          parent_component: "media",
          child: true,
        },
      });
    },
    closeDrawer_i() {
      this.drawer_i = false;
      document.documentElement.style.overflow = "auto";
      if (this.$refs.iDetail && typeof this.$refs.iDetail.closeParentDrawer === "function") {
        this.$refs.iDetail.closeParentDrawer();
      }
      this.$router.push({
        name: "media",
        params: {
          backpage: true,
        },
      });
    },
    clearList() {
      this.checkAll_val = false;
      this.checkList = [];
    },
    checkAll(val) {
      const allPost = [];
      for (let i = 0; i < this.list.media.length; i++) {
        allPost[i] = this.list.media[i].media_id;
      }
      this.checkList = val ? allPost : [];
    },
    checkAll_pagination(type) {
      let allPost = [];
      if (type == "auto") {
        if (this.check_list_status == "all") type = "unselect";
        if (this.check_list_status == "some") type = "unselect";
        if (this.check_list_status == "none") type = "select";
      }
      if (type == "select") {
        for (let i = 0; i < this.list.media.length; i++) {
          allPost[i] = this.list.media[i].media_id;
        }
        this.checkList = allPost;        
      } else if (type == "unselect") {
        for (let i = 0; i < this.list.media.length; i++) {
          if (this.checkList.includes(this.list.media[i]['media_id'])) {
            var index = this.checkList.indexOf(this.list.media[i]['media_id']);
            this.checkList.splice(index, 1);
          }            
        }
      } else if (type == "selectAll") {
        this.checkList = [];
        this.checkList = this.checkList.concat(this.media_all);
      } else if (type == "unselectAll") {
        this.checkList = [];
      }
    },
    imgDetailLoaded() {
      this.detail_loading = false;
    },
    imgError(index) {
      this.list.media[index].profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    searchDropdown(value) {
      this.search_dropdown_regexp = new RegExp(value, "ig");
    },
    searchDropdownAdd(value) {
      this.search_dropdown_add_regexp = new RegExp(value, "ig");
    },
    imgDetailError() {
      this.detail_loading = false;
    },
    normalizeCreativeSns(media) {
      if (!media || media.sns_type == null || media.sns_type === "") return "instagram";
      const s = String(media.sns_type).toLowerCase();
      if (s === "x" || s === "twitter") return "twitter";
      return "instagram";
    },
    externalPostUrl(media) {
      if (!media) return "";
      if (media.post_url) return media.post_url;
      if (this.normalizeCreativeSns(media) === "twitter") {
        const raw = media.tweet_id != null && media.tweet_id !== "" ? media.tweet_id : media.shortcode;
        if (raw == null || String(raw).trim() === "") return "";
        return "https://x.com/i/status/" + encodeURIComponent(String(raw).trim());
      }
      return "https://www.instagram.com/p/" + media.shortcode + "/";
    },
    externalPostLabel(media) {
      return this.normalizeCreativeSns(media) === "twitter" ? "X→" : "Instagram→";
    },
  },
  watch: {
    $route(to) {
      if (to.name == "media" && !to.params.backpage) {
        this.drawer_i = false;
        this.loadQuery();
      }
    },
    media_search: {
      handler() {
        this.next_cursor = "";
      },
      deep: true,
    },
  },
  filters: {
    searchHighlight(value, keyword, pr) {
      if (keyword) {
        if (pr == true) {
          const keyword_rep0 = keyword.replace(/OR/g, "|");
          const keyword_rep1 = keyword_rep0.replace(/"/g, "");
          const keyword_rep2 = keyword_rep1.replace(/\s/g, "|");
          const keyword_rep3 = keyword_rep2 + "|" + pr_word;
          const keyword_RegExp = new RegExp(keyword_rep3, "ig");
          return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
        } else {
          const keyword_rep1 = keyword.replace(/OR/g, "|");
          const keyword_rep2 = keyword_rep1.replace(/"/g, "");
          const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
          const keyword_RegExp = new RegExp(keyword_rep3, "ig");
          return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
        }
      } else {
        if (pr == true) {
          const keyword_RegExp = new RegExp(pr_word, "ig");
          return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
        } else {
          return value;
        }
      }
    },
  },
};
</script>

<style></style>
